import { clamp } from 'lodash';
import React, { useEffect, useRef } from 'react';

import { Divider, LinearProgress } from '@mui/material';

import animate from 'utils/animate';

import useStyles from './styles';

import { GENERATION_STEPS, GENERATION_STEPS_PROGRESS_MAP, GenerationStep as GenerationStepType } from '../../constants';
import GenerationStep from '../GenerationStep';

interface Props {
    step: GenerationStepType;
    className?: string;
}

const SCROLL_DURATION = 500;

const GenerationProgress: React.FC<Props> = ({ step: active, className }) => {
    const { classes, cx } = useStyles();
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const element = document.querySelector(`[data-generation-step=${active}]`);
        const scrollable = containerRef.current;

        if (element && scrollable) {
            const delta = element.getBoundingClientRect().right - scrollable.getBoundingClientRect().right;
            const from = scrollable.scrollLeft;

            window.setTimeout(() => {
                animate({
                    duration: SCROLL_DURATION,
                    easing: animate.easing.easeInOutCubic,
                    onProgress: (progress) => scrollable.scrollTo(from + progress * delta, 0)
                });
            }, 0);
        }
    }, [active]);

    return (
        <div className={cx(classes.root, className)}>
            <LinearProgress
                value={clamp(GENERATION_STEPS_PROGRESS_MAP[active][1], 0, 1) * 100}
                variant="determinate"
                className={classes.progress}
            />
            <div className={classes.steps} ref={containerRef}>
                {GENERATION_STEPS.map((step, index) => (
                    <React.Fragment key={step}>
                        {index === 0 ? null : <Divider />}
                        <GenerationStep
                            value={step}
                            variant={
                                step === active
                                    ? 'active'
                                    : GENERATION_STEPS.indexOf(active) > GENERATION_STEPS.indexOf(step)
                                    ? 'completed'
                                    : 'default'
                            }
                        />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default GenerationProgress;
